import { picklistApi } from 'api';
import {
  generatePicklistPdf,
  generateBatchPicklistPdf,
} from 'utils/pdfGenerators';
import { PICKLIST_TYPES } from 'constants/admin/warehouse';
import paths from 'routes/paths';

// The app path is /:tenant/:warehouse/... — same derivation as BaseApi.
const getBatchPickingUrl = picklistId => {
  const [tenant, warehouse] = window.location.pathname
    .split('/')
    .filter(Boolean);
  if (!tenant || !warehouse) return null;
  return `${window.location.origin}${paths.picklists.livePicking(
    tenant,
    warehouse,
    picklistId,
  )}`;
};

/**
 * Print the picklist PDF, branching on the picklist's type snapshot.
 *
 * - barcode mode: product-batch rows (existing template)
 * - batch_code mode: one row per shipment with cart partition numbers
 *
 * Pass `picklistType` when the caller already has it (list row, detail data)
 * to avoid an extra request; otherwise it is fetched from the detail API.
 */
export const printPicklistPdf = async (
  picklistId,
  picklistCode,
  picklistType = null,
) => {
  let type = picklistType;

  if (!type) {
    const picklist = await picklistApi.getById(picklistId);
    type = picklist?.picklist_type;
  }

  if (type === PICKLIST_TYPES.BATCH_CODE) {
    const response = await picklistApi.getShipmentPartitions(picklistId);
    generateBatchPicklistPdf(
      response,
      picklistCode,
      getBatchPickingUrl(picklistId),
    );
  } else {
    const response = await picklistApi.getProductBatchesOfPicklist(picklistId);
    generatePicklistPdf(response.results, picklistCode);
  }
};
